export const IGNORED_ERRORS = [
  'Tried to emit action [update], but WebSocket not open',
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  'AbortError: The user aborted a request.',
  'SecurityError: Blocked a frame with origin "https://app.savvywealth.com" from accessing a cross-origin frame. Protocols, domains, and ports must match.',
];

// `window.onerror` matches against `err.toString()`, which prefixes the class
// ("AbortError: The user aborted a request."). RUM reports the same fault with
// `error.message` unprefixed and the class in `error.type`, so IGNORED_ERRORS
// entries do not all match a RUM event and the two lists have to stay separate.
//
// Chrome's current ResizeObserver wording is deliberately absent: DES2-180 has it
// looping on the household page at ~28 sessions a day, so it is the detector for
// a live regression rather than background noise. Add it once that is fixed.
export const RUM_IGNORED_ERROR_MESSAGES = [
  'ResizeObserver loop limit exceeded',
  'The user aborted a request.',
  'signal is aborted without reason',
];
